import { Reviews } from '__generated__/api';
import { ManagementResponseViewModel, UserReviewViewModel } from 'models/hotel';
import { PhotoViewModel } from 'models/common';

export const mapUserReview = (review: Reviews.Reviews): UserReviewViewModel => ({
  contentLocale: review.locale as string,
  photos: review.photos.map(mapReviewPhoto),
  reviewId: review.id,
  title: review.title,
  reviewText: review.text,
  ratingOverall: review.ratingOverall,
  author: review.author,
  userLocation: review.userLocation,
  reviewSubmissionTime: review.submissionTime.raw,
  locationRemarks: review.locationRemarks,
  positiveRemarks: review.positiveRemarks,
  negativeRemarks: review.negativeRemarks,
  managementResponses: review.managementResponses.map(mapManagementResponse),
  totalThanks: Number(review.helpfulReviewVotes),
  stayDuration: review.stayDuration,
  superlative: review.superlative
});

const mapReviewPhoto = (photo: Reviews.Photos): PhotoViewModel => ({
  caption: photo.description,
  normalUrl: photo.url,
  thumbnailUrl: photo.url
});

const mapManagementResponse = (response: Reviews.ManagementResponses): ManagementResponseViewModel => ({
  date: response.date,
  displayLocale: response.displayLocale,
  response: response.response,
  id: response.id,
  userNickname: response.userNickname
});
